import { Checkbox, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { Folder } from '@material-ui/icons';
import React, { useCallback } from 'react';
import { useSelection } from "../hooks/use-selection.js";

/**
 * Represents a selection list component.
 */
export function SelectionList(props) {
  const {
    selection,
    setSelection
  } = useSelection();
  const onCheckedChangeHandler = useCallback((_event, node) => {
    setSelection(selection.filter(item => item.Id !== node.Id));
  }, [selection, setSelection]);
  const defaultRenderer = useCallback(item => {
    var _props$renderIcon;

    const labelId = `checkbox-list-label-${item.Id}`;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.Id,
      button: true
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Checkbox, {
      color: "primary",
      edge: "start",
      checked: true,
      onChange: e => onCheckedChangeHandler(e, item),
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        'aria-labelledby': labelId
      }
    })), /*#__PURE__*/React.createElement(ListItemIcon, null, ((_props$renderIcon = props.renderIcon) === null || _props$renderIcon === void 0 ? void 0 : _props$renderIcon.call(props, item)) || /*#__PURE__*/React.createElement(Folder, {
      style: {
        color: 'primary'
      }
    })), /*#__PURE__*/React.createElement(ListItemText, {
      id: labelId,
      primary: item.DisplayName,
      secondary: item.Path.replace(new RegExp('^/Root', 'g'), '')
    }));
  }, [onCheckedChangeHandler, props]);
  const renderItem = props.renderItem || defaultRenderer;
  return /*#__PURE__*/React.createElement(List, null, selection.map(item => renderItem(item)));
}
//# sourceMappingURL=selection-list.js.map